<div class="field">
    <cl-toggleswitch [inputId]="inputId()" [formControl]="control()" />
    <label [for]="inputId()">{{ label() }}</label>
</div>
<app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
